export default __webpack_public_path__ + "static/media/Ellipse 116.93cff30f.svg";